import { render, staticRenderFns } from "./ImageMetadata.vue?vue&type=template&id=32e4dd2c&scoped=true"
import script from "./ImageMetadata.vue?vue&type=script&lang=js"
export * from "./ImageMetadata.vue?vue&type=script&lang=js"
import style0 from "./ImageMetadata.vue?vue&type=style&index=0&id=32e4dd2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e4dd2c",
  null
  
)

export default component.exports